import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';

import {AuthService} from './auth.service';
import {CacheStorageService} from './cache-storage.service';
import {ConfigService} from './config.service';
import {LogService} from './log.service';


@Injectable()
export class GridService {
	constructor (
		private http: Http,

		private authService: AuthService,
		private cacheStorage: CacheStorageService,
		private config: ConfigService,
		private log: LogService
	) {}


	createGrid(payload: any) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);
// console.log('payload');
// console.log(payload);
// console.log('body');
// console.log(body);

			this.http.post(this.config.basePath + '/v0/grids', body, options)
				.toPromise()
				.then( (res) => {
					let foo = res.json();

					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}


	updateGrid(payload: any) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/grids/' + payload.gridId, body, options)
				.toPromise()
				.then( (res) => {
					let foo = res.json();

					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}


	deleteGrid(gridId: string) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			this.http.delete(this.config.basePath + '/v0/grids/' + gridId, options)
				.toPromise()
				.then((res) => {
					let result = res.json();

					// console.log(result);
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}


	getGrids() {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/grids', options)
				.toPromise()
				.then( (res) => {
					let foo = res.json();

					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/grid.service.ts